"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const uuid_1 = require("uuid");
const AppBar_1 = __importDefault(require("@mui/material/AppBar"));
const Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const EmbeddedRegister_1 = __importDefault(require("components/EmbeddedRegister"));
const BudgetNode_1 = __importDefault(require("components/Budgets/BudgetNode"));
const objectCache_1 = require("utils/objectCache");
const AnnualViewTable_1 = __importDefault(require("containers/BudgetsV2/components/AnnualViewTable"));
const constants_1 = require("containers/BudgetsV2/constants");
const AnnualSpendingChart_1 = __importDefault(require("../AnnualSpendingChart"));
const hooks_1 = require("../../hooks");
const styles_1 = __importDefault(require("./styles"));
let nodeIndex = 0;
const mountId = (0, uuid_1.v4)();
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const BudgetEmbedded = ({ navigationPath, isLoading, budget, transactions, budgetTreeNodes, accountIds, budgetsCreation, onTxnUpdate, handleNavigationClick, budgetUiState, setBudgetUiState, dashboardRef, }) => {
    const { classes, theme } = useStyles();
    const [transactionsBarStuck, setTransactionsBarStuck] = (0, react_1.useState)(false);
    const { budgetView } = (0, hooks_1.useBudgetOptions)(budget.id, dashboardRef);
    (0, react_1.useEffect)(() => {
        let transactionsBarObserver = null;
        const transactionsBarSentinel = document.querySelector('#transactionsBarSentinel');
        if (transactionsBarSentinel && typeof IntersectionObserver !== 'undefined') {
            transactionsBarObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setTransactionsBarStuck(false);
                    }
                    else {
                        setTransactionsBarStuck(true);
                    }
                });
            }, {
                root: null,
                threshold: 0,
            });
            transactionsBarObserver === null || transactionsBarObserver === void 0 ? void 0 : transactionsBarObserver.observe(transactionsBarSentinel);
        }
        return () => {
            transactionsBarObserver === null || transactionsBarObserver === void 0 ? void 0 : transactionsBarObserver.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (isLoading)
        return null;
    return (<div className={classes.root} id="container">
      {budgetView === constants_1.BUDGET_VIEWS.annual.key ? (<div className={classes.content} id="annual-view">
          <AnnualSpendingChart_1.default budgetId={budget.id}/>
          <AnnualViewTable_1.default budget={budget} budgetUiState={budgetUiState} setBudgetUiState={setBudgetUiState} updateBudgetCalcAndItems={onTxnUpdate}/>
        </div>) : (<>
          <div className={classes.content} id="budgetItems">
            <div id="budgetsBarSentinel" className={classes.transactionsBarSentinel}/>
            {budgetTreeNodes && budgetTreeNodes.size > 0 ?
                <Paper_1.default className={classes.barSection}>
                <div className={classes.breadCrumbWrapper}>
                  <button id="budgets-title" className={(0, classnames_1.default)(classes.pathButton, { isLastLeaf: !navigationPath })} color="primary" disabled={!navigationPath} onClick={() => handleNavigationClick(null)} type="button">
                    {budget && budget.name}
                  </button>
                  {navigationPath && navigationPath.map((node, i) => (<span key={node.key}>
                      <span className={classes.pathDivider}>/</span>
                      <button id={`budgets-path-${i}`} className={(0, classnames_1.default)(classes.pathButton, { isLastLeaf: i === navigationPath.length - 1 })} color="primary" onClick={() => handleNavigationClick(node)} type="button">
                        {node.displayLabel}
                      </button>
                    </span>))}
                </div>
                {budgetTreeNodes.map((node) => (<React.Fragment key={node.key}>
                    <BudgetNode_1.default index={nodeIndex++} // eslint-disable-line no-plusplus
                     key={node.key} style={{ padding: 20 }} budget={budget} node={node} showChildLink={!navigationPath} editInPlace={!budgetsCreation} isParent/>
                    {navigationPath && navigationPath.length > 0 && node.children &&
                            node.children.map((childNode) => (<BudgetNode_1.default index={nodeIndex++} // eslint-disable-line no-plusplus
                             key={childNode.key} style={{ padding: 20, paddingLeft: 60 }} showChildLink budget={budget} node={childNode} editInPlace={!budgetsCreation}/>))}
                  </React.Fragment>))}
              </Paper_1.default>
                :
                    <ZeroStateView_1.default primary=" " secondary="There are no budget items to display."/>}
          </div>

          <AppBar_1.default position="sticky" color="default" elevation={transactionsBarStuck ? 5 : 0} className={classes.header} onClick={(event) => {
                event.stopPropagation();
                const element = document.querySelector('#transactionsBarSentinel');
                if (element && window.scrollTo) {
                    window.scrollTo({ left: 0, top: element.offsetTop, behavior: 'smooth' });
                }
            }}>
            <Paper_1.default elevation={0} square>
              <Toolbar_1.default className={classes.headerContent}>
                <div id="budgets-transactions-heading" className={classes.transactionsHeader}>
                  {'Transactions for '}
                  <span style={{ fontWeight: 500, color: theme.palette.text.primary }}>
                    {navigationPath && navigationPath.length > 0
                ? navigationPath[navigationPath.length - 1].displayLabel
                : budget && budget.name}
                  </span>
                </div>
              </Toolbar_1.default>
            </Paper_1.default>
          </AppBar_1.default>
          <div id="budgetsBarSentinel" className={classes.transactionsBarSentinel}/>
          {transactions && transactions.size > 0 ?
                <div id="transactions" className={classes.content} style={{ height: 568 }}>
              <EmbeddedRegister_1.default name={`Reg_Budgets-${mountId}`} overrideTxns={(0, objectCache_1.cacheableObject)(transactions)} currency={budget && budget.currency} 
                // @ts-expect-error: showControls/hideDividers/hideSearch/noNew not in EmbeddedRegisterProps
                showControls hideDividers hideSearch noNew bottomMargin={0} accountIds={(0, objectCache_1.cacheableObject)(accountIds)} onTxnUpdate={onTxnUpdate}/>
            </div> :
                <ZeroStateView_1.default size="small" primary=" " secondary="There are no transactions to display."/>}
          <div style={{ height: theme.spacing(3) }}>&nbsp;</div>
        </>)}
    </div>);
};
exports.default = React.memo(BudgetEmbedded);
